// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/polygon-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about estimated gas cost of a transaction
 * @export
 * @interface GasEstimate
 */
export interface GasEstimate {
    /**
     * 
     * @type {string}
     * @memberof GasEstimate
     */
    gasLimit: string;
}

/**
 * Check if a given object implements the GasEstimate interface.
 */
export function instanceOfGasEstimate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gasLimit" in value;

    return isInstance;
}

export function GasEstimateFromJSON(json: any): GasEstimate {
    return GasEstimateFromJSONTyped(json, false);
}

export function GasEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GasEstimate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gasLimit': json['gasLimit'],
    };
}

export function GasEstimateToJSON(value?: GasEstimate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gasLimit': value.gasLimit,
    };
}

